<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { smoothScroll } from "../actions";
  import Logo from "./Logo.svelte";

  let scrolled = $state(false);
  let open = $state(false);

  $effect(() => {
    const onScroll = () => (scrolled = window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  });

  const nav = $derived([
    { href: "#how", label: i18n.t.nav.how },
    { href: "#features", label: i18n.t.nav.features },
    { href: "#demo", label: i18n.t.nav.demo },
    { href: "#pricing", label: i18n.t.nav.pricing },
    { href: "#faq", label: i18n.t.nav.faq },
  ]);
</script>

<header class="hdr" class:scrolled>
  <div class="container bar">
    <a href="#top" class="brand" use:smoothScroll aria-label="Tane home">
      <Logo size={36} />
      <span class="word">Tane</span>
    </a>

    <nav class="nav" class:open aria-label="Primary">
      <ul>
        {#each nav as item}
          <li>
            <a href={item.href} use:smoothScroll onclick={() => (open = false)}>
              {item.label}
            </a>
          </li>
        {/each}
      </ul>
    </nav>

    <div class="actions">
      <button class="lang" onclick={() => i18n.toggle()} aria-label="Switch language">
        {i18n.t.langSwitch}
      </button>
      <a href="#cta" class="btn btn-primary cta" use:smoothScroll>{i18n.t.nav.cta}</a>
      <button
        class="burger"
        class:open
        onclick={() => (open = !open)}
        aria-label="Menu"
        aria-expanded={open}
      >
        <span></span><span></span>
      </button>
    </div>
  </div>
</header>

<style>
  .hdr {
    position: sticky;
    top: 0;
    z-index: 100;
    transition:
      background-color 0.4s var(--ease),
      border-color 0.4s var(--ease),
      backdrop-filter 0.4s var(--ease);
    border-bottom: 1px solid transparent;
  }
  .hdr.scrolled {
    background: rgba(245, 241, 231, 0.82);
    backdrop-filter: blur(12px) saturate(1.1);
    border-bottom-color: var(--line);
  }
  .bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 74px;
  }

  .brand {
    display: inline-flex;
    align-items: center;
    gap: 0.55em;
  }
  .brand:hover :global(.seal) {
    transform: rotate(-5deg) scale(1.05);
  }
  .word {
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 1.45rem;
    letter-spacing: -0.01em;
    color: var(--ink);
  }

  .nav ul {
    display: flex;
    gap: clamp(1rem, 0.3rem + 1.4vw, 2.1rem);
  }
  .nav a {
    font-size: 0.92rem;
    font-weight: 500;
    color: var(--ink-soft);
    position: relative;
    padding-block: 0.4em;
    transition: color 0.3s var(--ease);
  }
  .nav a::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0.1em;
    width: 100%;
    height: 1.5px;
    background: var(--green);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s var(--ease);
  }
  .nav a:hover {
    color: var(--ink);
  }
  .nav a:hover::after {
    transform: scaleX(1);
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 0.8rem;
  }
  .lang {
    font-family: var(--font-mono);
    font-size: 0.72rem;
    letter-spacing: 0.1em;
    color: var(--ink);
    padding: 0.5em 0.8em;
    border: 1px solid var(--line-strong);
    border-radius: 999px;
    transition:
      border-color 0.3s var(--ease),
      background-color 0.3s var(--ease);
  }
  .lang:hover {
    border-color: var(--ink);
    background: rgba(23, 39, 29, 0.04);
  }
  .cta {
    padding: 0.6em 1.15em;
    font-size: 0.86rem;
  }

  .burger {
    display: none;
    flex-direction: column;
    gap: 5px;
    padding: 8px 4px;
  }
  .burger span {
    width: 22px;
    height: 1.6px;
    background: var(--ink);
    transition: transform 0.35s var(--ease);
  }
  .burger.open span:first-child {
    transform: translateY(3.3px) rotate(45deg);
  }
  .burger.open span:last-child {
    transform: translateY(-3.3px) rotate(-45deg);
  }

  @media (max-width: 900px) {
    .nav {
      position: fixed;
      inset: 74px 0 auto 0;
      background: rgba(245, 241, 231, 0.97);
      backdrop-filter: blur(14px);
      border-bottom: 1px solid var(--line);
      clip-path: inset(0 0 100% 0);
      transition: clip-path 0.45s var(--ease);
    }
    .nav.open {
      clip-path: inset(0 0 0 0);
    }
    .nav ul {
      flex-direction: column;
      gap: 0;
      padding: 1rem var(--gutter) 2rem;
    }
    .nav li {
      border-bottom: 1px solid var(--line);
    }
    .nav a {
      display: block;
      padding: 1rem 0;
      font-size: 1.05rem;
    }
    .burger {
      display: flex;
    }
    .cta {
      display: none;
    }
  }
</style>
